import { useNavigate } from 'react-router-dom';
import '../../css/TemplatesPage.css';
import TemplateCard from '../../components/template/TemplateCard';
import { useEffect, useState } from 'react';
import api from '../../api/axios';
import Header from '../../layouts/Header';
import Footer from "../../layouts/Footer";
import AuthPopup from '../../components/popup/AuthPopup';


export default function TemplatesComponent({ role }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([])
    const [showAuth, setShowAuth] = useState(false);;

    const handleUseTemplate = (t) => {
        if (role == 'public') {
            setShowAuth(true);
            return;
        }
        navigate(`/${role}/editor`, { state: { templateId: t.template_id, layout: t.template_layout } });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getTemplates();
    }, []);

    const getTemplates = async () => {
        try {
            setLoading(true);
            const response = await api.get(role == 'public' ? "/template/home/list" : "/template/list");
            if (response && response.data && response.data.success) {
                const templates = response.data?.data?.list || response.data?.data;
                setTemplates(templates);
                setLoading(false);
            } else {
                setLoading(false);
                setTemplates([]);
            }
        } catch (err) {
            setLoading(false);
            console.log(err?.data?.message);
        }
    };

    return (
        <>
            {role == 'public' && (<Header loginClick={() => { setShowAuth(true) }} />)}
            {role == 'public' && (<div className='mt-10'></div>)}
            <div className="templates-page" style={{ padding: role == 'public' ? '8rem' : null }}>

                <div className="flex items-start justify-between gap-4">
                    <div>
                        <h1 className="premium-page-title">Templates</h1>
                        <p className="text-sm text-black-500">
                            Pick a starting point — beautiful CTV-ready layouts you can customize in the editor.
                        </p>
                    </div>
                </div>

                {loading ? (
                    <div className="flex h-80 items-center justify-center">
                        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
                    </div>
                ) : (
                    <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 xl:grid-cols-3">
                        {templates
                            .map((t) => (
                                <TemplateCard
                                    key={t.template_id}
                                    t={t}
                                    handleUseTemplate={handleUseTemplate} />
                            ))}
                    </div>
                )}

            </div>
            <AuthPopup
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />
            {role == 'public' && (<Footer />)}
        </>
    );
}

